import * as React from 'react';
import { Button as BootstrapButton } from 'react-bootstrap';
import classNames from 'classnames';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

import classes from './button.module.scss';

export type ButtonProps = React.ComponentPropsWithoutRef<
  typeof BootstrapButton
> & {
  loading?: boolean;
  variant?: 'primary' | 'secondary';
};

export const Button: React.FC<ButtonProps> = ({
  className,
  loading = false,
  variant = 'primary',
  ...props
}) => (
  <BootstrapButton
    className={classNames(
      classes.button,
      classes[variant],
      loading && classes.loading,
      className
    )}
    disabled={loading}
    {...props}
  />
);

type ButtonLinkProps = LinkProps &
  React.ComponentPropsWithRef<'a'> & {
    variant?: string;
  };

export const ButtonLink: React.FC<ButtonLinkProps> = ({
  variant = 'primary',
  className,
  ...props
}) => (
  <RouterLink
    className={classNames(classes.button, classes[variant], className)}
    role={'button'}
    {...(props as any)}
  />
);
